import { SxProps, Theme } from "@mui/system";

export const columnStyles = {
  labelStyle: {
    color: "#151C28",
    fontWeight: 600,
    fontSize: ["10px", "18px"],
    "&.MuiTableCell-root ": {
      paddingY: ["11px", "27px"],
      paddingX: ["0px", "11px"],
    },
  },
  cellStyle: {
    "&.MuiTableCell-root ": {
      paddingX: "0px",
    },
    fontSize: ["10px", "16px"],
    paddingY: ["11px", "26px"],
    paddingX: ["0px", "11px"],
  },
};

export const EmptyContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  marginTop: "67px",
};

export const EmptyOrdersSVG = {
  maxWidth: "420px",
};

export const actionButtonStyle = (isMobile: boolean): SxProps<Theme> => ({
  width: isMobile ? "80px" : "131.22px",
  height: isMobile ? "24px" : "29px",
  padding: isMobile ? "2px 8px" : "4px 12px",
  fontSize: isMobile ? "8px" : "14px",
  gap: "10px",
  borderRadius: "60px",
  border: "1px solid #333333",
  backgroundColor: "#E9E9E9",
  "&.MuiButton-contained": {
    borderWidth: "1px",
  },
  color: "#000",
});
